import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmwayFilledLogoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.1181 37.302L39.8209 38.1049L11.8828 41.2943L12.9974 39.2566L40.1181 37.302ZM25.8847 15.6887L28.1862 24.4326H23.703L25.8847 15.6887ZM28.5445 10.7057H23.1646L15.9614 33.401H21.2518L22.5967 28.5785H29.3518L30.7267 33.401H36.0468L28.5445 10.7057Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgAmwayFilledLogoIcon);
export { ForwardRef as ReactComponent };
